<template>
  <main-bg>
    <!-- 用户登录页 -->
    <el-tabs tab-position="top" stretch :value="tabs">
      <el-tab-pane label="账号密码登录" key="user_login">
        <phone-login/>
      </el-tab-pane>
      <el-tab-pane label="短信验证码登录" key="sms_login">
        <sms-login/>
      </el-tab-pane>
    </el-tabs>
  </main-bg>
</template>

<script>
import PhoneLogin from './components/PhoneLogin'
import SmsLogin from './components/SmsLogin'
// import { encodeBase64 } from '@/utils/base64'
import mainBg from '@/views/layout/mainBg'


export default {
  name: 'Login',
  components: {
    PhoneLogin,
    SmsLogin,
    mainBg
  },
  computed: {
    // 从忘记密码页点『使用手机验证码登录』进入时自动切换到第二个tab
    tabs() {
      return this.$route.query.tabs ? '1' : '0'
    }
  },
}
</script>

<style lang="scss" scoped>
.el-tab-pane {
  padding-top: 0;
}
.el-tabs /deep/ .el-tabs__header {
  margin-bottom: 0;
}
</style>